
import { Component, Vue } from "vue-property-decorator";
import AppLogo from "@/layouts/ui/app-logo.vue";

@Component({
  name: "auth-layout",
  components: { AppLogo },
})
export default class AuthLayout extends Vue {}
